import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { RepresentativeSimpleForm } from 'domains/Representative/components'
import { Button, Title } from '@qonsoll/react-design'
import { Form, DatePicker, Input } from 'antd'
import { KEYS } from '__constants__'
import {
  useInitializeRepresentativeAdvancedForm,
  useActionsRepresentativeAdvancedForm
} from './hooks'
import { PhoneInput } from '@qonsoll/react-design'

const RepresentativeAdvancedForm = (props) => {
  const { initialData, group, showTitle } = props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const { form } = useInitializeRepresentativeAdvancedForm(initialData)

  // [HANDLERS]
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      onFinish()
    }
  }

  const { loading, onFinish, onReset } = useActionsRepresentativeAdvancedForm({
    initialData,
    form
  })

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Representative')}
        </Title>
      )}
      <RepresentativeSimpleForm
        showTitle={false}
        group={[...group, 'representative']}
      />
    </>
  ) : (
    <Form
      onKeyPress={handleKeyPress}
      onFinish={onFinish}
      layout="vertical"
      autoComplete="off"
      form={form}>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Representative')}
        </Title>
      )}
      <RepresentativeSimpleForm group={['representative']} />
      <Button mr={2} htmlType="button" onClick={onReset} mb={4}>
        {t('Cancel')}
      </Button>
      <Button type="primary" loading={loading} onClick={() => form.submit()}>
        {t('Save')}
      </Button>
    </Form>
  )
}

RepresentativeAdvancedForm.propTypes = {
  initialData: PropTypes.object,
  group: PropTypes.array,
  showTitle: PropTypes.bool
}

export default RepresentativeAdvancedForm
